/** @module modal */

import MicroModal from 'micromodal';
import { liveEvents } from '../../../../../assets/js/application';
import { eventListenerOptions } from '@spinnwerk/polyfills';

/**
 * Initializes modal functionalities.
 * Should not be referenced directly.
 *
 * @param {object} [options={}] - Options for the modal.
 * @param {boolean} [options.blockScrolling=false] - Whether the site's scrolling is blocked while the modal is open.
 *
 * @private
 * @see {@link modal}
 */
export function initModal({ blockScrolling = false }) {
    MicroModal.init({
        openTrigger: 'data-modal-open',
        closeTrigger: 'data-modal-close',
        awaitOpenAnimation: true,
        onShow(modal) {
            if (blockScrolling) {
                document.documentElement.style.overflow = 'hidden';
            }

            document.querySelector(`[data-modal-open="${modal.id}"]`).setAttribute('aria-expanded', 'true');
        },
        onClose(modal) {
            if (blockScrolling) {
                document.documentElement.style.overflow = '';
            }

            document.querySelector(`[data-modal-open="${modal.id}"]`).setAttribute('aria-expanded', 'false');
        },
    });

    // the MicroModal package does not close the modal, if the closing-button has child-elements, that are clicked.
    // the following code fixes this
    liveEvents().then((events) => {
        events.addEventListener(
            '.modal__container [data-modal-close]',
            'click',
            (event) => {
                if (event.target.matches('[data-modal-close]') === false) {
                    MicroModal.close(event.target.closest('.modal').id);
                }
            },
            eventListenerOptions({ passive: true }),
        );
    });
}
